import styled from 'styled-components';

import {
  Checkbox,
  Popover,
  PopperContent,
  PopoverHeader,
  color,
} from '@workboard/wobo-ui';

export const StyledPopover = styled(Popover)`
  z-index: 15;

  ${PopoverHeader}[data-testid='wbui-header'] {
    border: 0;
    padding: 16px 12px;
    max-height: 52px;
    min-width: 340px;
  }

  [data-testid='wbui-popover'] {
    div div [data-testid='wbui-popover-content'] {
      padding: 0 12px;
    }
  }

  ${PopperContent}[data-testid='wbui-popover-content'] {
    padding: 0 12px;
  }

  h1 {
    font-family: ${({ theme }) => theme['--font']};
    font-size: ${({ theme }) => theme.typography.fontSize}px;
    font-weight: ${({ theme }) => theme.typography.fontWeightBold};

    div span {
      font-weight: ${({ theme }) => theme.typography.fontWeightBold};
    }
  }

  ${Checkbox} {
    .MuiCheckbox-root {
      .MuiIconButton-label {
        svg.MuiSvgIcon-root {
          fill: ${color('--gray-500')};
        }
      }

      &.Mui-disabled {
        .MuiIconButton-label {
          svg.MuiSvgIcon-root {
            fill: ${color('--gray-300')};
          }
        }
      }

      &.Mui-checked {
        .MuiIconButton-label {
          svg.MuiSvgIcon-root {
            fill: ${color('--blue-400')};
          }
        }

        &.Mui-disabled {
          .MuiIconButton-label {
            svg.MuiSvgIcon-root {
              fill: ${color('--gray-300')};
            }
          }
        }
      }
    }
  }
`;
